import { ResearchPerfEvalCriteriaItemForm } from '@/module/ResearchPerfEval/form/ResearchPerfEvalCriteriaItemForm';
import { EvalTemplateCriteriaType } from '@/module/ResearchPerfEval/model/EvalTemplateTypes';
import { useResearchPerfEvalEditCriteriaItem } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';
import { BaseCriteriaItemSchema } from '@/module/ResearchPerfEval/model/ResearchPerfEvalSchema';
import { ResearchPerfEvalCriteriaDataItem } from '@/module/ResearchPerfEval/model/ResearchPerfEvalTypes';

import { Id, useAppNotification } from '@feature/utils';

interface ResearchPerfEvalCriteriaItemEditProps {
  close: () => void;

  evaluationId: Id;
  authorId: Id;
  orderNo: number;

  editItem: ResearchPerfEvalCriteriaDataItem;
  criteriaType: EvalTemplateCriteriaType;

  dataEntryHint: string | null;

  alreadySelectedIds: number[];
}

export function ResearchPerfEvalCriteriaItemEdit(props: ResearchPerfEvalCriteriaItemEditProps) {
  const { close, evaluationId, authorId, orderNo, editItem, criteriaType, dataEntryHint, alreadySelectedIds } = props;
  const { mutate, isPending } = useResearchPerfEvalEditCriteriaItem(evaluationId, authorId, orderNo, editItem.id);
  const notification = useAppNotification();
  const onSubmit = (values: BaseCriteriaItemSchema) => {
    mutate(
      {
        ...values,
        item: {
          ...values,
          criteriaType,
        },
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };
  return (
    <ResearchPerfEvalCriteriaItemForm
      onCancel={close}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      defaultValues={{
        ...editItem,
        ...(editItem.item || {}),
      }}
      criteriaType={criteriaType}
      dataEntryHint={dataEntryHint}
      evaluationId={evaluationId}
      authorId={authorId}
      orderNo={orderNo}
      alreadySelectedIds={alreadySelectedIds}
    />
  );
}
